module.exports = __webpack_public_path__ + "static/media/amazon_web_services.7b8fcb14.svg";